<template>
  <div>
    <div class="form-group">
      <MPowerGoogleAutocomplete
        ref="autocomplete"
        v-model="addressValue"
        @place_changed="setPlace"
        no-label
        :placeholder="
          data.city
            ? `${data.street1}${data.street2 ? ' ' + data.street2 : ''}, ${data.city}, ${data.state} ${data.zip}`
            : 'Search for address...'
        "
      />
      <!--
      <div v-if="data.city">
        <small>Current Location</small>
        <div>{{data.street1}}{{data.street2 ? ' ' + data.street2 : ''}}, {{data.city}}, {{data.state}} {{data.zip}}</div>
      </div>
      -->
      <small>
        <a @click="insertManually = !insertManually">{{ !insertManually ? 'Manual Edit' : 'Hide' }}</a>
      </small>
    </div>
    <div v-show="insertManually">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import MPowerGoogleAutocomplete from '@mtntop/utils/src/components/AddressFields/MPowerGoogleAutocomplete.vue';

export default {
  components: {
    MPowerGoogleAutocomplete
  },
  data() {
    return {
      insertManually: this.showManually,
      addressValue: ''
    };
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => null
    },
    showManually: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async setPlace(place) {
      let street = '';
      const ac = place.address_components;
      const lat = place.geometry.location.lat;
      const lon = place.geometry.location.lng;
      this.$set(this.data, 'lng', lon);
      this.$set(this.data, 'lat', lat);
      for (const index in ac) {
        for (const field in ac[index]) {
          if (field === 'types') {
            const longValue = ac[index].long_name;
            const shortValue = ac[index].short_name;
            switch (ac[index][field][0]) {
              case 'locality':
                this.$set(this.data, 'city', longValue);
                break;
              case 'street_number':
                street = `${street + longValue} `;
                break;
              case 'route':
                street += longValue;
                break;
              case 'country':
                if (shortValue === 'US') {
                  this.$set(this.data, 'country', 'USA');
                } else if (['MX'].indexOf(shortValue) > -1) {
                  this.$set(this.data, 'country', shortValue);
                }
                break;
              case 'administrative_area_level_1':
                this.$set(this.data, 'state', longValue);
                break;
              case 'postal_code':
                this.$set(this.data, 'zip', parseInt(longValue));
                break;
              default:
            }
          }
        }
      }
      this.$set(this.data, 'street1', street);
      this.$emit('selected', this.data);
    }
  }
};
</script>
